// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3PWmi","title":"classes_title__31eW_","left":"classes_left__3ETK-","closed-filter":"classes_closed-filter__3FCxo"};